import { MailUnreadNumUpdateData } from "../../handler/mail/ws-types";
import EventBus from "../event-bus";
const unreadNumUpdateHook = new EventBus<MailUnreadNumUpdateData>(
  "unreadNumUpdateHook"
);

export default unreadNumUpdateHook;
